import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@Sage/hoi-poi-ui';
import { MergeIcon } from 'components/icons';
import { getLiteral, getLiteralWithParameters } from 'utils/getLiteral';

const propTypes = {
    mainEntity: PropTypes.string,
    entity: PropTypes.object,
    schema: PropTypes.array,
    onSelectEntity: PropTypes.func,
};

const AdvancedSearchSelected = memo(({ mainEntity, entity, schema, onSelectEntity, literals }) => {
    let field = schema.find((field) => {
        return field.title;
    });
    let title = entity[field.field];

    return (
        <div className="selected-column">
            <div className="title-selected-column">
                <span className="text">{title}</span>
            </div>
            <div className="content-selected-column">
                <MergeIcon style={{ color: '#8D8D8D', fontSize: 30 }} />
                <div className="content-column">
                    {getLiteralWithParameters(literals.labelHelpMergeDuplicates, [mainEntity])}
                </div>
                <Button onClick={onSelectEntity({ value: { key: entity['Id'] } })}>
                    {getLiteral(literals.labelActionSelect)}
                </Button>
            </div>
        </div>
    );
});

export default AdvancedSearchSelected;
